import api from "./api";

export interface AvaliationPhotoMonthRecord {
  id: number;
  professional: number;
  user: number;
  year_month: string;
  photo_frente: string | null;
  photo_costas: string | null;
  photo_lateral_direita: string | null;
  photo_lateral_esquerda: string | null;
  url_frente: string | null;
  url_costas: string | null;
  url_lateral_direita: string | null;
  url_lateral_esquerda: string | null;
  created_at: string;
}

export async function listMonthlyPhotosForStudent(
  studentId: string
): Promise<AvaliationPhotoMonthRecord[]> {
  const { data } = await api.get<AvaliationPhotoMonthRecord[]>(
    "/avaliation-photo-month/",
    { params: { user_id: studentId } }
  );
  return Array.isArray(data) ? data : [];
}
